import { redirect } from "react-router";
import { Csrf } from "@lending/types";

export const OLB_FLOW_APPLICATION_UUID_QUERY_PARAM_KEY = "olb_application";
export const CROSS_SELL_APPLICATION_UUID_QUERY_PARAM_KEY = "cross_sell_application";

const baseUrl = `${import.meta.env.VITE_PUBLIC_API_URL}`;

function checkQueryParam() {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;

  const olbApplicationUuid = searchParams.get(OLB_FLOW_APPLICATION_UUID_QUERY_PARAM_KEY);
  const crossSellApplicationUuid = searchParams.get(CROSS_SELL_APPLICATION_UUID_QUERY_PARAM_KEY);

  if (olbApplicationUuid) {
    return olbApplicationUuid;
  }

  if (crossSellApplicationUuid) {
    return crossSellApplicationUuid;
  }
}

function getRedirectSearch(searchParams: URLSearchParams) {
  const redirectSearchParams = new URLSearchParams(searchParams);

  redirectSearchParams.delete("token");
  redirectSearchParams.delete(OLB_FLOW_APPLICATION_UUID_QUERY_PARAM_KEY);
  redirectSearchParams.delete(CROSS_SELL_APPLICATION_UUID_QUERY_PARAM_KEY);

  const redirectSearch = redirectSearchParams.toString();

  return redirectSearch ? `?${redirectSearch}` : "";
}

async function bootstrapApp({ endpoint, routePrefix }: { endpoint: string; routePrefix: string }) {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;

  const uuidFromQueryParam = checkQueryParam();
  if (uuidFromQueryParam) {
    return redirect(
      `/${routePrefix}/${uuidFromQueryParam}/confirm-info${getRedirectSearch(searchParams)}`
    );
  }

  try {
    const token = searchParams.get("token");

    if (!token) {
      return redirect("/error");
    }

    const headers = new Headers({
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    });

    const csrfTokenResp = await fetch(`${baseUrl}/v2/lending/csrf`, {
      headers,
      credentials: "include",
    });
    const csrfToken = (await csrfTokenResp.json()) as Csrf;

    headers.set("X-CSRFToken", csrfToken.token);

    const prequalAppResp = await fetch(`${baseUrl}${endpoint}`, {
      method: "POST",
      headers,
      credentials: "include",
    });

    if (!prequalAppResp.ok) {
      return redirect("/error");
    }

    const prequalAppRespJson = (await prequalAppResp.json()) as { id: string };
    const { id: uuid } = prequalAppRespJson;

    searchParams.delete("token");
    searchParams.set(OLB_FLOW_APPLICATION_UUID_QUERY_PARAM_KEY, uuid);
    history.replaceState(null, "", url.toString());

    return redirect(`/${routePrefix}/${uuid}/confirm-info${getRedirectSearch(searchParams)}`);
  } catch (error) {
    console.error("Failed to load pre-qualification application:", error);
    return redirect("/error");
  }
}

export async function loadPrequalApp() {
  return bootstrapApp({
    endpoint: "/v2/lending/personal_loan_applications/pre_qualification/",
    routePrefix: "olb-personal-loan",
  });
}

export async function loadCreditCardPrequalApp() {
  return bootstrapApp({
    endpoint: "/v2/lending/credit_card_applications/pre_qualification/",
    routePrefix: "olb-credit-card",
  });
}

export async function loadAutoLoanPrequalApp() {
  return bootstrapApp({
    endpoint: "/v2/lending/vehicle_loan_applications/pre_qualification/",
    routePrefix: "olb-auto-loan",
  });
}
